import { TerminSearchBlock } from "@/components/blocks/termin-search-block";
import { TerminEventSearchPageProps } from "@/pages/termin-event-search-page/types";
import { useState } from "react";
import { TerminEventFilterSection } from "./termin-event-filter-section";


export function TerminEventSearchPage(initial: TerminEventSearchPageProps) {
    const [events, setEvents] = useState(initial.terminTabel.events);


    return (
        <div className={"flex flex-col gap-4 pb-10"}>

            <TerminEventFilterSection setEvents={setEvents} initial={initial} />
            <div className="px-4 sm:px-0">
                <TerminSearchBlock
                    hideSeeAll={initial.terminTabel.hideSeeAll}
                    events={events}
                    translation={initial.terminTabel.translation}
                />
            </div>
        </div>
    )
} 